import {
    signinModalId,
    removeAfterCheckoutRedirection,
    setAfterCheckoutRedirection,
    setAfterLoginRedirection,
    removeAfterLoginRedirection,
    setLoginUrl,
    requestForModalOnNextPage,
    alertNotification,
    successNotification,
    showSpinner,
    hideSpinner,
    apiEP,
    apiPostWithPromise,
    apiPut,
    requestDatalayerPushNextPage,
    cookieNames,
    managePostLoginAffiliateV2,
    sentryAPIError,
    sentryAPIErrorV2,
    bookPostLoginAction,
    setUEmail,
    nextModalOpenVar,
    nextModalOpenVarData,
    funnelUpdate,
    frontendSubscribeLink,
    alternativeCheckoutLink,
    websiteUrl,
    protectedApiCallRetry,
} from './module_common';

import { 
    cleanCheckoutSetting,
    sendVerificationEmail,
    needToMove,
    doNotRedirectToProfileOnProblemSendingEmailModalClose,
 } from './module_checkout_helper';

import { openModal } from './module_modal';

import { emailSubmitSelector } from './module_common_selector';

import { 
    firebaseUserExist,
    firebaseSignInWithEmailAndPassword,
    firebaseCreateUserWithEmailAndPassword,
    firebaseSendPasswordResetEmail,
    firebaseSigninWithPopup,
    firebaseSignInWithRedirect,
    firebaseGetRedirectResult,
    firebaseUpdateUserName,
    firebaseGetUserToken,
    firebaseDeleteUser,
    firebaseUpdateEmail,
    firebaseGetCurrentUser,
    firebaseLogout,
    firebaseSignInWithEmailLink,
} from './module_firebase';

import {
    GoogleAuthProvider,
    FacebookAuthProvider,
    OAuthProvider,
} from 'firebase/auth';

import {dataContainerSelector} from './module_common_selector';

let rLUs = false;
let showLeavingUserModal = true;

let redirectAfterLogin = true;

// const isInWebView = $(dataContainerSelector).data("iswv")
const isInWebView = false

export function setRedirectAfterLogin(val){
    redirectAfterLogin = val
}

export function logout(){
    const p = window.location.hostname.split(".");
    let domain = p.slice(-2).join(".");
    const cookiesToDeleteArray = $(dataContainerSelector).data("delcook").split(' ')
    
    for (const cookieName of cookiesToDeleteArray) {
        Cookies.remove(cookieName)
        document.cookie = `${cookieName}= ; expires = Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=${domain};`
        document.cookie = `${cookieName}= ; expires = Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=.${domain};`
    }

    return firebaseLogout()
}

export function logoutAndReload(){
    logout()
        .then(function(){
            window.location.reload();
        })
        .catch(function(err){
            // TODO
            // manage error
            window.location.reload();
        })
}

// reset to initial status,
// hide email form
function hideLoginMailForm () {
    $('.login-email-form').css('max-height', 0);
    $('.login-email-cta').removeClass('d-none');
}

function switchLoginModalRetarget (isRetarget) {
    if (isRetarget) {
        $("#"+signinModalId+" .modal-top").addClass("retargeting");
        $("#"+signinModalId+" .modal-body .padded").addClass("retargeting");
    } else {
        $("#"+signinModalId+" .modal-top").removeClass("retargeting");   
        $("#"+signinModalId+" .modal-body .padded").removeClass("retargeting");   
    }
};

const retargetLeavingUsers = function () {
    if (UIDg) return null; // Logged in
    if (rLUs) return null; // Already shown same page
    if ($("body").hasClass("modal-open")) return null   // some modal already open

    const alreadyShown = Cookies.get('_rlu_4b');
    // already shown last 24h
    if (alreadyShown) { 
        rLUs = true;
        return null;
    }

    switchLoginModalRetarget(true);
    openSignInModal()
    
    Cookies.set('_rlu_4b', true, {expires: 1});
};

export function attachDocumentLeaveForRetarget () {
    if (!showLeavingUserModal) return
    $(document).mouseleave(function (e) {
        if (e.clientY < 100) {
            retargetLeavingUsers();
        }
    });
}

export function disableLeavingUserModal(){
    showLeavingUserModal = false
}

export function attachSignInRedirect(){
    // navbar for visitor
    $(".signin-and-redir-attach-clk").on('click', function(e){
        if (alternativeCheckoutLink){
            window.location = frontendSubscribeLink
        }else{
            const el = $(e.currentTarget)
            const link = el.data("redir")
            openSignUpAndGotoUrl(link)
        }
    })
}

export function openSignUpAndGotoUrl(link){
    openModalAndGotoUrl(signinModalId, link)
}

class AuthHelperError extends Error {
    constructor(...params) {
        super(...params);
        this.name = "AuthHelperError"
    }
}

export function handleUserLoginWithCallbackNoPremium(callBack, premiumMsg, setLoggedFnc, setPremiumFnc){
    return async function handle(e){
        hideSpinner()
        const usrDetail = e.detail
        setLoggedFnc()
        if (usrDetail.is_new){
            if (usrDetail.verified){
                callBack()
            }else{
                document.body.addEventListener("emailVerificationFlowDone", (e) => {
                    callBack()
                })
            }
        }else{
            showSpinner()
            Cookies.set('Authorization', usrDetail.access_token);
            Cookies.set("Refresh", usrDetail.refresh_token);
            const url = `/users/${usrDetail.user_id}/premium`
            let isPremiumResp
            try {
                isPremiumResp = await protectedApiCallRetry('GET', url, null, 3)
            } catch (error) {
                hideSpinner()
                alertNotification(genericRetryErrMsg)
                const err = new AuthHelperError("Error during premium call", {cause: error})
                const contextData = {data: usrDetail}
                sentryAPIErrorV2(err, contextData)
                return
            }
            hideSpinner()
            if (isPremiumResp.outcome){
                successNotification(premiumMsg)
                setPremiumFnc()
                return;
            }
            callBack()
        }    
    }
}

async function handleUserLoginAlternative(e){
    hideSpinner()
    const usrDetail = e.detail
    if (usrDetail.is_new){
        if (usrDetail.verified){
            // do something
        }else{
            document.body.addEventListener("emailVerificationFlowDone", (e) => {
                // do something after user close email-verification popup
            })
        }
    }else{
        // do something example check if user is premium...
    }
}

function manageBuyButtonClickAlternative(){
    setRedirectAfterLogin(false)
    doNotRedirectToProfileOnProblemSendingEmailModalClose()
    document.body.addEventListener("userLogged", handleUserLoginAlternative)
    // dont use openSignInModal, infinite loop
    openModalAndGotoUrl(signinModalId)
}

// change this function to modify
// login flow
export function openSignInModal(){
    // for example use 
    // manageBuyButtonClickAlternative()
    // to use custom "userLogged" event

    openModalAndGotoUrl(signinModalId)
}

export function signInGoToCheckoutAndBack(){
    openModalAndGotoUrl(signinModalId, frontendSubscribeLink, '', window.location.href)
}

export function openModalAndGotoUrl(modalId, url, secondModalOpen, afterCheckoutRedirectionUrl) {
    secondModalOpen = secondModalOpen || '';

    afterCheckoutRedirectionUrl = afterCheckoutRedirectionUrl || '';
    if (!afterCheckoutRedirectionUrl) {
        removeAfterCheckoutRedirection();
    } else {
        setAfterCheckoutRedirection(afterCheckoutRedirectionUrl);
    }

    url = url || '';
    if (url.length) {
        setAfterLoginRedirection(url)
    }

    // never used ....
    requestForModalOnNextPage(secondModalOpen);
    
    hideLoginMailForm();
    switchLoginModalRetarget(false);

    openModal('#' + modalId, "openModalAndGotoUrl")
    return false;
}

// unused, only for reference
export function openLoginModalAndGoToSubscribePopup(loginModalId, tryPremiumModalId, url) {
    const modalDataObj = {
        key: 'afterCheckoutUrl', 
        value: url, 
        notOnPremium: true,
    }
    requestForModalOnNextPage(tryPremiumModalId, modalDataObj);
    
    hideLoginMailForm();
    switchLoginModalRetarget(false);

    openModal('#' + loginModalId, 'openLoginModalAndGoToSubscribePopup')
    return false;
}

export function handleNavbarOpenLoginModal(e){
    e.preventDefault()
    e.stopImmediatePropagation()
    hideLoginMailForm();
    switchLoginModalRetarget();
    // pure login modal, 
    // openSignInModal can handle some condition for signin temp change
    openModalAndGotoUrl(signinModalId)
}

const emailFormSelector = "#emailForm";
const emailInputSelector = "#username";
const socialLoginSelector = ".social-login-attach-clk";
const showLoginMailSelector = ".show-login-mail-attach-clk";

const passInputSelector = "#passwordH";
const passSubmitSelector = ".pass-submit-attach-clk";
const passFormSelector = "#passwordForm";
const forgotPassSelector = '.forgot-pass-attach-clk';

const signupSubmitSelector = ".signup-submit-attach-clk";
const signupFormSelector = "#registerForm"
const signupNameInputSelector = "#name"
const signupPassInputSelector = "#password"
const signupMarketingPrefsInputSelector = "#updating"

function getMarketingPref(){
    return $(signupMarketingPrefsInputSelector)[0].checked
}

function setMarketingPreference(){
    const action = cookieNames.postLoginActions.actions.setSignupMarketingPref.label
    const marketing = getMarketingPref()
    bookPostLoginAction(action, marketing)
}

function attachSignupSubmit(){
    const submit = $(signupSubmitSelector)
    const form = $(signupFormSelector)
    submit.on("click", function(e){
        if ($(e.currentTarget).hasClass("disabled")) return
        setMarketingPreference()
        manageSignUpWithEmailAndPass()
    })
    // works on 'enter' press in input field
    form.on("submit", function(e)
    {
        e.preventDefault()
        if ($(e.currentTarget).hasClass("disabled")) return
        setMarketingPreference()
        manageSignUpWithEmailAndPass()
    });
}

function checkEmailAndGoOn() {
    var form = $('#emailForm');
    var emailField = form.find('input[name="username"]');
    var btn = $(".email-submit-attach-clk");
    var email = emailField.val();
    form.removeClass("was-validated").addClass("was-validated");
    if (!emailField.is(':valid')) return 
    
    btn.addClass("disabled")
    showSpinner();
    // perform whitelisting and blacklisting checks
    // then check if firebase user exist
    $.ajax({
        method: 'GET',
        url: apiEP('/auth/validate/' + email),
        dataType: 'json',
        success: function (data) {
            $(emailSubmitSelector).removeClass("disabled")
            hideSpinner();
            if (data && data["ok"]) {
                firebaseUserExist(email)
                    .then(exist => {
                        if (exist){
                            askForPasswordModal(email);
                        }else{
                            openSignupModal(email);
                        }
                    })
                    .catch(function(err){
                        switch (err) {
                            case 'too-many-requests':
                                alertNotification(messages.verificationEmail.errorTooManyAttempts);
                                break
                            case 'invalid-email':
                                alertNotification("Invalid email");
                                break
                        }
                    })
            } else {
                alertNotification(messages.verificationEmail.blockedDomain);
            }
        },
        error: function () {
            $(emailSubmitSelector).removeClass("disabled")
            alertNotification(messages.verificationEmail.error4unlogged);
            hideSpinner();
        }
    })
}

function openSignupModal(email) {
    // open other modal only when current is close, 
    // unless 'modal-open' class won't be added to body
    $("#"+signinModalId).on('hidden.bs.modal', function(e){
        $("#"+signinModalId).off('hidden.bs.modal')
        openModal('#signupModal', 'openSignupModal')
        var formEl = $("#registerForm");
        var emailEl = formEl.find('input[name="email"]');
        emailEl.val(email);
    })
    handleLoginModalManuallyClose();
}

let mainModalManuallyClose = false;
let signupModalManuallyClose = false;

// TODO
// rename closeLoginModal
function handleLoginModalManuallyClose() {
    mainModalManuallyClose = true
    $("#"+signinModalId).modal('hide');
}

function handlesignupModalManuallyClose() {
    signupModalManuallyClose = true
    $("#signupModal").modal('hide');
}

const attachSignInModalCloseEvent = function(){
    $("#"+signinModalId).on('hidden.bs.modal', function(){
        if (!mainModalManuallyClose){
            // close by user
            cleanLogInSettings()
        }
        mainModalManuallyClose = false
    })
}

const attachSignupModalCloseEvent = function(){
    $("#signupModal").on('hidden.bs.modal', function(){
        if (!signupModalManuallyClose){
            // close by user
            cleanLogInSettings()
        }
        signupModalManuallyClose = false
    })
}

// call on 'hidden.bs.modal' event
// every time mainModal is closed (by user or manually)

function askForPasswordModal(email) {
    // open other modal only when current is close, 
    // unless 'modal-open' class won't be added to body
    $("#"+signinModalId).on('hidden.bs.modal', function(e){
        $("#"+signinModalId).off('hidden.bs.modal')
        openModal('#requestPwModal', 'askForPasswordModal')
        var pf = 'passwordForm';
        var form = $('#' + pf);
        var emailEl = form.find('input[name="emailH"]');
        //Set hidden input
        emailEl.val(email);
    })
    handleLoginModalManuallyClose();
}

function sendEmailButtonDisableToggle(){
    const email = $(emailInputSelector);
    const submit = $(emailSubmitSelector);

    email.on("input", (e) => {
        const inputValue = e.target.value
        if (inputValue == "") {
            if (!submit.hasClass("disabled")) submit.addClass("disabled")
        } else {
            if (submit.hasClass("disabled")) submit.removeClass("disabled")
        }
    });
}

function attachEmailSubmit(){
    const submit = $(emailSubmitSelector);
    const form = $(emailFormSelector);
    submit.on("click", function(e){
        const target = $(e.currentTarget)
        if (target.hasClass("disabled")) return
        checkEmailAndGoOn();
    })
    // works on 'enter' press in input field
    form.on("submit", function(e)
    {
        e.preventDefault()
        checkEmailAndGoOn();
    });
}

function attachEmailLoginClickFromModal(){
    $(showLoginMailSelector).on("click", function(){
        const emailInput = $(emailInputSelector)[0]
        if (emailInput.value !== ""){
            const submit = $(emailSubmitSelector);
            if (submit.hasClass("disabled")) submit.removeClass("disabled")
        }
        // show email field on same modal
        $('.login-email-form').css('max-height', 500);
        $('.login-email-cta').addClass('d-none');
        $(".login-email-input").focus();
    })
}

function attachPassSubmit(){
    const submit = $(passSubmitSelector);
    const form = $(passFormSelector);
    submit.on("click", function(e){
        const target = $(e.currentTarget)
        if (target.hasClass("disabled")) return
        setMarketingPreference()
        manageEmailAndPassLogin()
    })
    // works on 'enter' press in input field
    form.on("submit", function(e)
    {
        e.preventDefault()
        setMarketingPreference()
        manageEmailAndPassLogin()
    });
}

function attachForgotPass(){
    const el = $(forgotPassSelector)
    el.on("click", function(){
        var form = $('#passwordForm');
        var emailEl = form.find('input[name="emailH"]');
        var email = emailEl.val();
        if (email) {
            firebaseSendPasswordResetEmail(email)
                .then(function () {
                    showModalPasswordResetted('');
                })
                .catch(function (error) {
                    showModalPasswordResetted(error);
                });
        }
    })
}

function attachSocialLogin(){
    const els = $(socialLoginSelector)
    els.on("click", function(e){
        const target =$(e.currentTarget)
        if (target.hasClass('google')){
            loginWithGoogle()
        }else if (target.hasClass('apple')){
            loginWithApple()
        }else if (target.hasClass('facebook')){
            loginWithFacebook()
        }else{
            return null
        }
    })
}

function loginWithGoogle() {
    setMarketingPreference()
    signinWithPopup(new GoogleAuthProvider());
    
    // firebaseSignInWithRedirect implementation is broken
    // handleSignInRedirect dont work

    // if (isInWebView) {
    //     const provider = new GoogleAuthProvider
    //     provider.setCustomParameters(
    //         {'prompt': 'select_account'}
    //     )
    //     firebaseSignInWithRedirect(provider)
    // } else {
    //     signinWithPopup(new GoogleAuthProvider());
    // }
}

function loginWithFacebook() {
    setMarketingPreference()
    signinWithPopup(new FacebookAuthProvider());

    // firebaseSignInWithRedirect implementation is broken
    // handleSignInRedirect dont work

    // if (isInWebView) {
    //     const provider = new FacebookAuthProvider
    //     provider.setCustomParameters(
    //         {'prompt': 'select_account'}
    //     )
    //     firebaseSignInWithRedirect(provider)
    // } else {
    //     signinWithPopup(new FacebookAuthProvider());
    // }
}

function loginWithApple() {
    setMarketingPreference()
    signinWithPopup(new OAuthProvider('apple.com'))
}

function signinWithPopup(provider) {
    firebaseSigninWithPopup(provider)
        .then(function (data) {
            const user = data.user;
            handleLoginModalManuallyClose();
            if (!user.email) {
                const FBtoken = data.credential.accessToken;
                requestForModalOnNextPage('emailRequiredModal');
                user.providerData.forEach(function (profile) {
                    if (profile.providerId === 'facebook.com') {
                        const uid = profile.uid;
                        const url = 'https://graph.facebook.com/v3.2/' + uid + '/permissions?access_token=' + FBtoken;
                        $.ajax({
                            method: 'DELETE',
                            url: url,
                            success: function (res) {},
                            error: function (err) {}
                        });
                    }
                });
                firebaseDeleteUser(user)
                    .catch((err)=>{
                        const contextData = {
                            customdata:{
                                function: "signinWithPopup",
                                err: err,
                                user: user,
                            }
                        }
                        const error = new Error('Error deleting user')
                        error.name = 'firebaseDeleteUser fail'
                        sentryAPIErrorV2(error, contextData)
                    })
                //Show modal with alert
                //Request modal on next page
                logoutAndReload()
            } else {
                if (afterSignin(data)){
                    VerifyFirebaseLogin(user);
                }
            }
        })
        .catch(function (error) {
            manageFirebaseAuthError(error, "signInWithPopup", "", provider);
        });
}

function showModalPasswordResetted(error) {
    $('#requestPwModal').modal('hide');
    if (error) {
        alertNotification(messages.profile.unableToResetPassword);
    } else {
        successNotification(messages.profile.successToResetPassword);
    }
}

function sendPassButtonDisableToggle(){
    const pass = $(passInputSelector);
    const submit = $(passSubmitSelector);

    pass.on("input", (e) => {
        const inputValue = e.target.value
        if (inputValue == "") {
            if (!submit.hasClass("disabled")) submit.addClass("disabled")
        } else {
            if (submit.hasClass("disabled")) submit.removeClass("disabled")
        }
    });
}

function sendSignupButtonDisableToggle(){
    const name = $(signupNameInputSelector);
    const pass = $(signupPassInputSelector);
    const submit = $(signupSubmitSelector);
    pass.on("input", (e) => {
        const inputValue = e.target.value
        if (inputValue == "") {
            if (!submit.hasClass("disabled")) submit.addClass("disabled")
        } else  if (name[0].value !== ""){
            if (submit.hasClass("disabled")) submit.removeClass("disabled")
        }
    });
    name.on("input", (e) => {
        const inputValue = e.target.value
        if (inputValue == "") {
            if (!submit.hasClass("disabled")) submit.addClass("disabled")
        } else if (pass[0].value !== ""){
            if (submit.hasClass("disabled")) submit.removeClass("disabled")
        }
    });
}

function manageEmailAndPassLogin(){
    var form = $("#passwordForm");
    form.removeClass("was-validated");
    const passField = form.find('input[name="passwordH"]');
    const emailField = form.find('input[name="emailH"]');
    const btn = $(".pass-submit-attach-clk")
    const email = emailField.val();
    const passwd = passField.val();
    form.addClass("was-validated");
    if (passField.is(':valid')) {
        btn.addClass("disabled");
        if (email && passwd) {
            firebaseSignInWithEmailAndPassword(email, passwd)
                .then(function (data) {
                    $('#requestPwModal').modal('hide');

                    if (afterSignin(data)) {
                        VerifyFirebaseLogin(data.user);
                    }
                })
                .catch(function (error) {
                    manageFirebaseAuthError(error, "signInWithEmailAndPassword", passField);
                    btn.removeClass("disabled");
                });
        } else {
            btn.removeClass("disabled");
        }
    }
}

function manageSignUpWithEmailAndPass(){
    var formEl = $("#registerForm");
    formEl.removeClass("was-validated").addClass("was-validated");
    if (formEl.is(":valid")) {
        const emailEl = formEl.find('input[name="email"]');
        const nameEl = formEl.find('input[name="name"]');
        const passwdEl = formEl.find('input[name="password"]');

        const name = nameEl.val();
        const email = emailEl.val();

        const btn = $(signupSubmitSelector);
        btn.addClass("disabled")
        luData.isRegistering = 1;
        
        firebaseCreateUserWithEmailAndPassword(email, passwdEl.val())
            .then(function (data) {
                handleLoginModalManuallyClose();
                handlesignupModalManuallyClose()
                const user = data.user;
                
                firebaseUpdateUserName(user, name)
                    .then(function () {
                        // Update successful.=> log to api
                        VerifyFirebaseLogin(user);
                    })
                    .catch(function (error) {
                        // An error happened.
                        // console.log("update-fiba-profile-failed", error);
                    });
            })
            .catch(function (error) {
                manageFirebaseAuthError(error, "createUserWithEmailAndPassword");
                btn.removeClass("disabled")
            });
    }
}

const afterLoginHooks = {};

function afterSignin(data) {
    if (afterLoginHooks.hasOwnProperty('updateEmailRequest')) {
        delete afterLoginHooks['updateEmailRequest'];
        openModal('#emailChangeModalId')
        return false;
    }
    return true;
}

function VerifyFirebaseLogin(user) {
    if (user) {
        firebaseGetUserToken(user)
            .then(function (data) {
                apiLogin(data);
            })
            .catch((err)=>{
                const error = new Error("Error getting the user token")
                error.name = "VerifyFirebaseLogin error"
                const contextData = {
                    apicalldata:{
                        function: "VerifyFirebaseLogin",
                        user: user,
                        error: err
                    }
                }
                sentryAPIErrorV2(error, contextData)
            })
    }
}

function doPostLoginActions(params){
    let data = Cookies.getJSON(cookieNames.postLoginActions.name);
    if (!data) {
        return null;
    }

    if (Object.keys(data).length){
        Object.keys(data).forEach( fnName => {
            if (typeof cookieNames.postLoginActions.actions[fnName].fn === "function") {
                cookieNames.postLoginActions.actions[fnName].fn(data[fnName], params);
            }
            delete(data[fnName]);
        })
    }
    Cookies.set(cookieNames.postLoginActions.name, data);
}

function setLoginCookies(data, fibaToken) {
    if (data['access_token']) {
        Cookies.set('Authorization', data['access_token'], {expires: 30, path: '/'});
    }
    if (data['refresh_token']) {
        Cookies.set('Refresh', data['refresh_token'], {expires: 30, path: '/'});
    }
    if (data['user_id']) {
        Cookies.set('User', data['user_id'], {expires: 30, path: '/'});
    }
    if (fibaToken) {
        Cookies.set('FibaToken', fibaToken);
    }
    setLoginUrl();
}

function cleanLogInSettings() {
    cleanCheckoutSetting();
    removeAfterLoginRedirection();
    Cookies.remove(nextModalOpenVar);
    Cookies.remove(nextModalOpenVarData);
}

function apiLogin(token) {
    //If our token is expired Call gateway auth
    const authT = Cookies.get('Authorization');
    const refrT = Cookies.get('Refresh');
    const fibaT = Cookies.get('FibaToken');
    if (authT && refrT && fibaT && (fibaT === token)) {
        needToMove();
        return;
    }
    const d = {firebase_jwt: token};
    // if (document.documentElement.lang && document.documentElement.lang === "it") {
    //     d["verified"] = true;
    // }
    const ep = '/auth/firebase';

    apiPostWithPromise(ep, d, false, true)
        .then((data) => {
            setLoginCookies(data, token);
            if (data && data["user_id"]) {
                UIDg = data["user_id"];
                setUEmail(data["email"])
            }
            // 
            doPostLoginActions({isNew: data['is_new']}); 
            return data
        })
        .then((data) => {
            return (x => managePostLoginAffiliateV2(data['is_new'])
                .then(()=>{
                    return x
                })
                .catch(()=>{
                    return x
                })
            )(data)
        })
        .then((data) => {
            if (data['is_new']) {
                hideSpinner()
                funnelUpdate("signup");
                // right now, in visitor page, we don't have intercom
                // and so, gtm fails to send message
                requestDatalayerPushNextPage({
                    event: "trackSignup",
                    userId: UIDg,
                    loginRequired: true,
                });
                if (!data['verified']){
                    // with redirectAfterLogin=true (default), redirect is done on verifyEmailModal close
                    sendVerificationEmail(data['user_id'], data['code'], redirectAfterLogin);
                    // default flow stops here for non-verified user
                    if (redirectAfterLogin) return
                }
            }
            if(!redirectAfterLogin) {
                const ev = new CustomEvent(
                    "userLogged",
                    {detail: data}
                )
                document.body.dispatchEvent(ev)
                return;
            }
            needToMove(true)
        })
        .catch((err) => {
            const error = new Error("Apilogin error in promise chain")
            error.name = "Apilogin fail"
            const contextData = {
                apicallData:{
                    function: "apiLogin",
                    error: err
                }
            }
            sentryAPIErrorV2(error, contextData)
        })
}

function apiLoginNoVerify(token) {
    const d = {firebase_jwt: token};
    const ep = '/auth/firebase';

    apiPostWithPromise(ep, d, false, true)
        .then((data) => {
            setLoginCookies(data, token);
            if (data && data["user_id"]) {
                UIDg = data["user_id"];
                setUEmail(data["email"])
            }
            doPostLoginActions({isNew: data['is_new']}); 
            return data
        })
        .then((data) => {
            return (x => managePostLoginAffiliateV2(data['is_new'])
                .then(()=>{
                    return x
                })
                .catch(()=>{
                    return x
                })
            )(data)
        })
        .then((data) => {
            if (data['is_new']) {
                hideSpinner()
                funnelUpdate("signup");
                // right now, in visitor page, we don't have intercom
                // and so, gtm fails to send message
                requestDatalayerPushNextPage({
                    event: "trackSignup",
                    userId: UIDg,
                    loginRequired: true,
                })
            }
            window.location = websiteUrl() + LL
        })
        .catch((err) => {
            const error = new Error("apiLoginNoVerify error in promise chain")
            error.name = "apiLoginNoVerify fail"
            const contextData = {
                apicallData:{
                    function: "apiLoginNoVerify",
                    error: err
                }
            }
            sentryAPIErrorV2(error, contextData)
        })
}

// call after a login with firebase signInWithRedirect, used in webview
const handleSignInRedirect = function(){
    // be sure go handle only in webview
    if (!isInWebView) return
    firebaseGetRedirectResult()
        .then(function(result) {
            // The signed-in user info.
            const user = result.user;
            if (!user) return
            if (!user.email) {
                const FBtoken = result.credential.accessToken;
                requestForModalOnNextPage('emailRequiredModal');
                user.providerData.forEach(function (profile) {
                    if (profile.providerId === 'facebook.com') {
                        const uid = profile.uid;
                        const url = 'https://graph.facebook.com/v3.2/' + uid + '/permissions?access_token=' + FBtoken;
                        $.ajax({
                            method: 'DELETE',
                            url: url,
                            success: function (res) {},
                            error: function (err) {}
                        });
                    }
                });
                firebaseDeleteUser(user)
                //Show modal with alert
                //Request modal on next page
                logoutAndReload()
            } else {
                if (afterSignin(result)){
                    VerifyFirebaseLogin(user);
                }
            }
        })
        .catch(function(error) {
            manageFirebaseAuthError(error, "getRedirectResult");
        })
}

export function prepareForEmailUpdate() {
    afterLoginHooks['updateEmailRequest'] = true;
    openSignInModal()
}

function apiEmailChange(token, updateFieldId, email) {
    const d = {firebase_jwt: token};
    const ep = '/auth/firebaseEmail';
    apiPut(
        ep, 
        d, 
        function (data) {
            $("#" + updateFieldId).html(email);

            if (dataLayer) {
                dataLayer.push({
                    event: "userEmailUpdate",
                    userId: luData.id,
                    emailOld: UEM,
                    emailNew: email
                });
            }
            UEM = email;
            luData.email = UEM;
            window.location.reload()
        },
        function (error) {
            alertNotification(messages['genericApiError']);
            sentryAPIError(ep, error, d, 'apiEmailChange');
        });
}

export function UpdateEmail() {
    var formEl = $("#updateEmailForm");
    formEl.removeClass("was-validated").addClass("was-validated");
    if (formEl.is(":valid")) {
        $('#emailChangeModalId').modal('hide');
        const newEmail = $("#newmail").val();
        const user = firebaseGetCurrentUser()
        // Must reauth
        if (user) {
            firebaseUpdateEmail(user, newEmail)
                .then(function () {
                    const user = firebaseGetCurrentUser()
                    firebaseGetUserToken(user)
                        .then(function (data) {
                            apiEmailChange(data, 'useremail', newEmail);
                        });
                })
                .catch(function (error) {
                    // An error happened.
                    sentryAPIError('firebaseUpdateEmail ', error, {
                        id: UIDg,
                        old: UEM,
                        newmail: newEmail
                    }, 'UpdateEmail');
                    if (error['code']) {
                        if (error.code === 'auth/email-already-in-use') {
                            alertNotification(messages['mailTaken']);
                            return;
                        }
                    }
                    if (error['message']) {
                        alertNotification(error['message']);
                        return;
                    }
                    alertNotification(messages['genericApiError']);
                });
        }
    }
}

function manageFirebaseAuthError(error, ref, el, provider) {
    const errorCode = error.code;
    const errorMessage = error.message;
    // The firebase.auth.AuthCredential type that was used.
    var credential = error.credential;
    if (error && error['code']) {
        const err = new Error("Firebase auth error", {cause: error})
        const contextData = {
            data:{
                function: ref,
            }
        }
        switch (errorCode) {
            case 'auth/wrong-password':
                $(".passHint").html(messages.profile.wrongPasswordHint);
                if (el) {
                    el.val('');
                    $(".pass-submit-attach-clk").addClass("disabled")
                }
                break;
            case 'auth/too-many-requests':
                alertNotification(messages.verificationEmail.errorTooManyAttempts);
                break;
            case 'auth/popup-closed-by-user':
                break;
            case 'auth/account-exists-with-different-credential':
                alertNotification(messages.verificationEmail.accountExistsWithDifferentCredential);
                break;
            case 'auth/popup-blocked':
                alertNotification(messages.signup.popupBlocked);
                err.name = "Firebase popup-blocked on "+ref
                if (provider){
                    err.name += ", "+provider.providerId+" provider"
                }
                contextData.data.errorcode = errorCode
                contextData.data.message = errorMessage
                contextData.data.credentialtype = JSON.stringify(credential)
                sentryAPIErrorV2(err, contextData)
                break
            case 'auth/cancelled-popup-request':
                alertNotification(messages.signup.popupCancelled);
                err.name = "Firebase cancelled-popup on "+ref
                if (provider){
                    err.name += ", "+provider.providerId+" provider"
                }
                contextData.data.errorcode = errorCode
                contextData.data.message = errorMessage
                contextData.data.credentialtype = JSON.stringify(credential)
                sentryAPIErrorV2(err, contextData)
                break
            case 'auth/user-cancelled':
                alertNotification(messages.signup.userCancelled);
                err.name = "Firebase user-cancelled on "+ref
                if (provider){
                    err.name += ", "+provider.providerId+" provider"
                }
                contextData.data.errorcode = errorCode
                contextData.data.message = errorMessage
                contextData.data.credentialtype = JSON.stringify(credential)
                sentryAPIErrorV2(err, contextData)
                break
            case 'auth/invalid-email':
                alertNotification(messages.verificationEmail.errorNotValidEmail)
                break;
            case 'auth/network-request-failed':
                alertNotification("Network error");
                break;
            default:
                alertNotification(messages.signup.generic);
                err.name = "Firebase auth error on "+ref
                if (provider){
                    err.name += ", "+provider.providerId+" provider"
                }
                contextData.data.errorcode = errorCode
                contextData.data.message = errorMessage
                contextData.data.credentialtype = JSON.stringify(credential)
                sentryAPIErrorV2(err, contextData)
        }
    }
}

// not used in logged page es. profile, library, search
// or page without login es. 4change, 4business, magazine
export function manageLogin(){
    attachSignInModalCloseEvent();
    attachSignupModalCloseEvent()

    sendEmailButtonDisableToggle()
    attachEmailSubmit()
    attachSocialLogin()
    attachEmailLoginClickFromModal()

    sendPassButtonDisableToggle()
    attachPassSubmit()
    attachForgotPass()

    sendSignupButtonDisableToggle()
    attachSignupSubmit()

    // handleSignInRedirect()

    // focus on pass input on passwordForm id form
    $('#requestPwModal').on('shown.bs.modal', function () {
        $(passInputSelector).focus();
    })

    $('#signupModal').on('shown.bs.modal', function () {
        $(signupNameInputSelector).focus();
    })
}

export function manageLoginFromEmailLink(email){
    showSpinner()
    firebaseSignInWithEmailLink(email, window.location.href)
        .then((userCredential) => {
            firebaseGetUserToken(userCredential.user)
                .then(function (data) {
                    apiLoginNoVerify(data);
                })
                .catch((error) => {
                    hideSpinner()
                    const err = new Error("Error getting the user token", {cause: error})
                    err.name = "VerifyFirebaseLoginForEmailLink error"
                    sentryAPIErrorV2(err)
                })
        })
        .catch((error) => {
            hideSpinner()
            if (error.code == 'auth/invalid-action-code'){
                alertNotification(messages.verificationEmail.errorInvalidActionCode)
                return
            }
            const err = new Error("Error during firebaseSignInWithEmailLink call", {cause: error})
            err.name = "ManageLoginFromEmailLink error"
            sentryAPIErrorV2(err)
        })
}